<template>
  <div class="input-container" :style="{ margin: margin, height: height }">
    <label :class="{ labelObrigatorio: ((campoVazio && required) || !isEmailValido) && showValidations }"> {{ label }}</label>
    <div v-if="temIcon" class="field">
      <p class="control has-icons-right">
        <input
          class="input"
          :id="id"
          type="email"
          :required="required"
          :placeholder="placeholder"
          :value="modelValue"
          @input="$event => setValue($event.target.value)"
          pattern="[0-9,a-z,A-Z,._%+-]{1,64}@[0-9,a-z,A-Z]{1,64}\.[0-9,a-z,A-Z]{2,4}"
          :class="{ inValida: ((campoVazio && required) || !isEmailValido) && showValidations }"
          :maxlength="maxLength"
          ref="inputEmail"
          :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
          @blur="validarEmail"
        />
        <span class="icon is-small is-right">
          <i class="mdi" :class="classIcon"></i>
        </span>
      </p>
    </div>

    <input
      v-else
      class="input"
      type="email"
      :placeholder="placeholder"
      :id="id"
      :maxlength="maxLength"
      :required="required"
      @keyup="$event => this.verificarSeInputEstaVazio($event,false)"
      pattern="[0-9a-zA-Z._+\-%]{1,64}@[0-9,a-z,A-Z]{1,64}\.[0-9,a-z,A-Z]{2,4}(\.br)?"
      :class="{ inValida: ((campoVazio && required) || !isEmailValido) && showValidations }"
      :value="modelValue"
      :disabled="isDisabled"
      @input="$event => setValue($event.target.value)"
      ref="inputEmail"
      :mensagemCampoObrigatorio="mensagemCampoObrigatorio"
      @blur="validarEmail"
    />

    <span v-if="tipLabel" class="tip-label is-size-7">{{ tipLabel }}</span>

    <div class="mensagemDeErro" v-if="showValidations">
      <span v-if="!isEmailValido" class="campo-obrigatório">
        Insira um e-mail válido.
      </span>

      <span v-else-if="mensagemCampoObrigatorio && campoVazio && required" class="campo-obrigatório">
        {{ mensagemCampoObrigatorio }}
      </span>

      <span v-else-if="campoVazio && required" class="campo-obrigatório">
        {{ label? label : "E-mail" }} é obrigatório.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfEmailInput",
  props: {
    label: String,
    placeholder: String,
    margin: String,
    height: String,
    temIcon: Boolean,
    classIcon: String,
    modelValue: String,
    required: {
      type: Boolean,
      default: true
    },
    id: String,
    maxLength: String,
    tipLabel: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    mensagemCampoObrigatorio: String
  },
  data() {
    return {
      campoVazio: false,
      isEmailValido: false,
      showValidations: false
    };
  },
  methods: {
    async setValue(value) {
      this.$emit('update:modelValue', value)
      await this.$nextTick()
      this.isEmailValido = !this.$refs.inputEmail.validity.patternMismatch
    },
    verificarSeInputEstaVazio(e,isInterno) {

      if (!isInterno) {
        this.showValidations = true
      }

      if (e?.keyCode == 32) {
        this.isEmailValido = false;
        return true
      }

      this.campoVazio = !this.modelValue || this.modelValue.trim() == "";
      this.verificarSeInputEValido()
      return this.campoVazio;
    },
    verificarSeInputEValido() {
      this.isEmailValido = !this.$refs.inputEmail.validity.patternMismatch
      return this.isEmailValido
    },

    limparValidacao() {
      this.campoVazio = false;
      this.showValidations = false;
    },
    
    limparInput() {
      this.modelValue == ''
    },

    validarEmail(e) {
      let email = e.target.value;

      if(!email) return;

      this.verificarSeInputEstaVazio(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.inValida {
  border: 1px solid #a94442;
}
.mensagemDeErro {
  margin: 0 0 1% 0;
  color: #a94442;
  font-size: 12px;
}
.labelObrigatorio {
  color: #a94442;
}
.tip-label {
  color: #4a4a4a;
  vertical-align: top;
}
</style>
